import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Button, Tooltip } from '@material-ui/core';
import _e from 'common/localeUtil';
import TooltipFieldHelp from './TooltipFieldHelp';

const useStyles = makeStyles(() => ({
	customWidth: {
		maxWidth: 500
	},
	mainText: {
		fontStyle: 'italic'
	}
}));

const ToolTipCustomDomain = () => {
	const classes = useStyles();

	const clickHelp = () => {
		window.gm_track(`FAQ - Custom Domain`);
		window.open(
			'https://goalsmapper.zendesk.com/knowledge/articles/900005254403/en-us?brand_id=114094850313',
			'noopener'
		);
	};

	return (
		<Tooltip
			interactive
			classes={{ tooltip: classes.customWidth }}
			placement="bottom"
			title={
				<TooltipFieldHelp
					message={
						<>
							{_e('yes_use_own_domain')}{' '}
							<Button onClick={clickHelp}>{_e('following_link')}</Button>
						</>
					}
				/>
			}
		>
			<span className={classes.mainText}>{_e('use_own_domain')}</span>
		</Tooltip>
	);
};

ToolTipCustomDomain.propTypes = {
	// message: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};

export default ToolTipCustomDomain;
